import ChartDataLabels from "chartjs-plugin-datalabels";
import { Bar, Line } from "react-chartjs-2";

import { configCGI, dataConfigCGI } from "./graph-cgi";
import { configLED, dataConfigLED } from "./graph-led";
import { configOnOff, dataConfigOnOff } from "./graph-on-off";
import { configTreatments, dataConfigTreatments } from "./graph-treatments";
import { configWeight, dataConfigWeight } from "./graph-weight";

const graphMetrics = [
  {
    id: "cgi",
    dataConfig: dataConfigCGI,
    options: configCGI,
    plugins: ChartDataLabels,
    element: Bar,
  },
  {
    id: "treatments",
    dataConfig: dataConfigTreatments,
    options: configTreatments,
    plugins: ChartDataLabels,
    element: Line,
  },
  {
    id: "onOff",
    dataConfig: dataConfigOnOff,
    options: configOnOff,
    plugins: ChartDataLabels,
    element: Bar,
  },
  {
    id: "led",
    dataConfig: dataConfigLED,
    options: configLED,
    plugins: ChartDataLabels,
    element: Bar,
  },
  {
    id: "weight",
    dataConfig: dataConfigWeight,
    options: configWeight,
    plugins: ChartDataLabels,
    element: Bar,
    className: "col-span-1 lg:col-span-2 w-full h-[400px]",
  },
];

export default graphMetrics;
